export const COUNTRY_DROPDOWN_PLACEHOLDER_TEXT = "activation.setup.competitors.step.ai.placeholder.choose.country";
export const COMMON_SEARCH_PLACEHOLDER = "common.countryFilter.placeholder.text";
